
<template>
<div class="collect-article-detail">
  <div v-if="article">
    <div style="background-color: white; padding: 10px">预览文章</div>
    <div
      style="
        background-color: white;
        padding: 0 10px 10px;
        font-weight: 600;
      "
    >
      {{ article.title }}
    </div>
    <div v-if="article && article.url">
      <a :href="article.url" target="_blank" style="text-decoration: none; color: #1890ff; font-size: 14px;">
        🔗 查看原文
      </a>
    </div>
    <div v-else-if="article" style="color: #999; font-size: 14px;">
      暂无原文链接
    </div>
    <div
      class="article-content"
      v-html="articleCon"
    ></div>
  </div>
  <el-dialog :title="keyword.name" :visible.sync="visible">
    <div v-if="keyword.list" class="keyword-detail">
      <div class="item" v-for="(item, idx) in keyword.list" :key="idx">
        <div v-html="item.content"></div>
        <p class="book">
          {{ item.bookName }}
        </p>
      </div>
    </div>
    <div v-else class="keyword-detail">
      <div v-html="keyword.desc"></div>
      <p class="book" v-if="keyword?.book">
        《{{ keyword.book.book_name }}》
      </p>
    </div>
  </el-dialog>
</div>
</template>
<script>
import request from '@/http/request';
import { Loading } from 'element-ui';
import { replaceKeyword } from '../../../utils/replaceKeyword';
export default {
  data () {
    return {
      visible: false,
      article: null,
      articleCon: '',
      keyword: {
        name: '',
        book: null,
        desc: ''
      },
      loadingInstance: null
    }
  },
  created () {
    this.$watch('$route.query', (newQuery) => {
      this.getDetail(newQuery.id)
    })
  },
  methods: {
    getContentText (con) {
      const el = document.createElement('div')
      el.innerHTML = con
      return el.textContent || el.innerText
    },
    
    // 清理和格式化文章内容
    cleanArticleContent(content) {
      if (!content) return ''
      
      let cleanedContent = content
      
      // 1. 清理段落标记 [p1][p1], [p2][p2], [p3][p3] 等
      cleanedContent = cleanedContent.replace(/\[p\d+\]\[p\d+\]/g, '')
      
      // 2. 清理单个段落标记 [p1], [p2], [p3] 等
      cleanedContent = cleanedContent.replace(/\[p\d+\]/g, '')
      
      // 3. 清理其他可能的标记
      cleanedContent = cleanedContent.replace(/\[\w+\]/g, '')
      
      // 4. 清理HTML实体和特殊字符
      cleanedContent = cleanedContent.replace(/&nbsp;/g, ' ')
      cleanedContent = cleanedContent.replace(/&amp;/g, '&')
      cleanedContent = cleanedContent.replace(/&lt;/g, '<')
      cleanedContent = cleanedContent.replace(/&gt;/g, '>')
      cleanedContent = cleanedContent.replace(/&quot;/g, '"')
      
      // 5. 清理不完整的HTML实体（如 &n）
      cleanedContent = cleanedContent.replace(/&\w*$/g, '')
      cleanedContent = cleanedContent.replace(/&\w+(?![a-zA-Z0-9;])/g, '')
      
      // 6. 清理多余的空白字符
      cleanedContent = cleanedContent.replace(/\s+/g, ' ')
      cleanedContent = cleanedContent.trim()
      
      // 7. 将数字编号转换为更好的格式
      cleanedContent = cleanedContent.replace(/(\d+)\.\s*/g, '<p><strong>$1. </strong>')
      
      // 8. 确保每个段落都有结束标签
      cleanedContent = cleanedContent.replace(/<p><strong>(\d+\. )<\/strong>([^<]*?)(?=<p><strong>|\s*$)/g, '<p><strong>$1</strong>$2</p>')
      
      // 9. 如果没有段落标签，添加基本的段落结构
      if (!cleanedContent.includes('<p>')) {
        // 按句号分段，但保留数字编号
        const sentences = cleanedContent.split(/(?<=。)\s*(?=\d+\.|\s*$)/).filter(s => s.trim())
        if (sentences.length > 1) {
          cleanedContent = sentences.map(sentence => `<p>${sentence.trim()}</p>`).join('')
        } else {
          cleanedContent = `<p>${cleanedContent}</p>`
        }
      }
      
      
      return cleanedContent
    },
    getDetail (paperId) {
      this.loadingInstance = Loading.service({
        fullscreen: true,
        text: '加载中...',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      // 判断是否为好友分享的文章
      const isSharedArticle = paperId && paperId.toString().startsWith('share-')
      
      if (isSharedArticle) {
        // 好友分享文章：提取分享记录ID并调用专用接口
        const shareId = paperId.toString().replace('share-', '')
        
        request('/api/wechatarticle/getFriendArticleById', {
          id: shareId
        }, 'post').then((result) => {
          if (result) {
            this.article = {
              id: result.id,
              title: result.title || '未命名文章',
              url: result.url || result.content,
              author: result.author_new || result.author,
              publish_time: result.publish_time_new || result.publish_time,
              content_show: this.cleanArticleContent(result.sum_up) || result.content || '暂无内容'
            }
            
            const articleCon = replaceKeyword(this.article.content_show)
            this.articleCon = articleCon
            this.$emit('getArticleData', {
              ...this.article,
              type: 'article'
            })
          } else {
            this.$message.error('未找到该分享文章的内容')
          }
          this.loadingInstance.close()
        }).catch((error) => {
          console.error('获取好友分享文章失败:', error)
          this.$message.error('获取分享文章失败，请重试')
          this.loadingInstance.close()
        })
      } else {
        // 普通文章：使用原有接口
        request('/api/wechatarticle/getArticleById', { id: paperId }).then((result) => {
          if (result && result.content_show) {
            this.article = result
            const articleCon = replaceKeyword(result.content_show)
            this.articleCon = articleCon
            this.$emit('getArticleData', {
              ...this.article,
              type: 'article'
            })
          } else {
            this.$message.error('文章内容为空或格式异常')
          }
          this.loadingInstance.close()
        }).catch(() => {
          this.$message.error('获取文章内容失败，请重试')
          this.loadingInstance.close()
        })
      }
    },
    
  },
  mounted () {
    const paperId = this.$route.query.id
    this.getDetail(paperId)
    document.addEventListener('click', (event) => {
      // 检查点击的元素是否是.keyword-tag
      if (event.target.matches('.keyword-tag')) {
        // 假设你有一个全局对象或者Vue实例来存储这些值
        const descr = event.target.getAttribute('descr')
        const bookId = event.target.getAttribute('tag')
        const info = event.target.getAttribute('info')
        const label = event.target.innerText
        const describe = descr.replace(/\\n?\\r/g, '<br><br>')
        let list = []
        if (info) {
          list = JSON.parse(info) || []
        }
        request('/api/Keywords/getBookInfoByKeywordsId', {
          book_keywords_id: bookId,
          book_keywords: label,
          description: describe
        }).then((res) => {
          if (res) {
            this.keyword = {
              name: label,
              book: res,
              desc: describe
            }
          } else {
            this.keyword = {
              name: label,
              desc: describe,
              list: list.length ? list : null
            }
          }
          this.visible = true // 假设visible是全局变量或者Vue实例的属性
        }).catch(() => {
          this.visible = true // 假设visible是全局变量或者Vue实例的属性
          this.keyword = {
            name: label,
            desc: describe
          }
        })
      }
    }, false) // fal
  }
}
</script>
<style lang="scss">
.collect-article-detail{
  margin-top: 10px;
  
  .article-content {
    background-color: #f7f7f7;
    height: 80vh;
    overflow-y: auto;
    padding: 20px;
    line-height: 1.8;
    font-size: 16px;
    color: #333;
    
    // 段落样式
    p {
      margin-bottom: 16px;
      text-align: justify;
      
      // 编号段落的特殊样式
      strong {
        color: #1890ff;
        font-weight: 600;
      }
    }
    
    // 滚动条样式
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 3px;
      
      &:hover {
        background: #a8a8a8;
      }
    }
  }
  
  .keyword-tag{
    color: #06f;
    cursor: pointer;
  }
  .book{
    font-weight: 600;
    color: #000;
    text-align: right;
  }
  .keyword-detail{
    max-height: 60vh;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 2px; /* 滚动条的宽度 */
    }
    &::-webkit-scrollbar-track {
      background: #f5f5f5;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #999;
      border-radius: 6px;
    }
  }
  .el-dialog__body {
    padding: 10px 20px 20px!important;
  }
}
</style>
